import axios from "axios";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { useContext, useMemo, useRef } from "react";
import AuthContext from "../context/AuthContext";
import { getIsLoggingOut, setIsLoggingOut } from "./AuthFlags";
import { API_BASE_URL } from "../config/apiConfig";


const baseURL = API_BASE_URL;
// 2.17

const useAxios = () => {
  const { authTokens, setUser, setAuthTokens, logoutUser } = useContext(AuthContext);
  const logoutUserRef = useRef(logoutUser);
  logoutUserRef.current = logoutUser;

  const axiosInstance = useMemo(() => {
    const instance = axios.create({
      baseURL,
      headers: { Authorization: `Bearer ${authTokens?.access}` },
    });

    instance.interceptors.request.use(
      async (req) => {
        if (!authTokens) return req;

        const user = jwtDecode(authTokens.access);
        const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

        if (!isExpired) return req;

        try {
          const response = await axios.post(`${baseURL}/token/refresh/`, {
            refresh: authTokens.refresh,
          });

          localStorage.setItem("authTokens", JSON.stringify(response.data));
          setAuthTokens(response.data);
          setUser(jwtDecode(response.data.access));

          req.headers.Authorization = `Bearer ${response.data.access}`;
          return req;
        } catch (err) {
          // Only logout once
          if (!getIsLoggingOut()) {
             setIsLoggingOut(true);
            logoutUserRef.current(true); // silent mode
          }
          return Promise.reject(err);
        }
      },
      (error) => Promise.reject(error)
    );

    return instance;
  }, [authTokens?.access, authTokens?.refresh, setAuthTokens, setUser]);

  return axiosInstance;
};

export default useAxios;
